// Long single values (emails, references, account names) never break mid-word: they end in an
// ellipsis (APP-DESIGN.md 8.4). This shows the whole value as a tooltip on whatever is cut off, so
// no element needs its own title.

/** The nearest element, from `el` up, whose text is cut off with an ellipsis. */
function clipped(el: Element | null): HTMLElement | null {
  for (let e = el; e && e !== document.body; e = e.parentElement) {
    if (!(e instanceof HTMLElement)) continue;
    if (getComputedStyle(e).textOverflow === 'ellipsis' && e.scrollWidth > e.clientWidth + 1) return e;
  }
  return null;
}

export function installTruncationTitles() {
  const show = (event: Event) => {
    const el = clipped(event.target as Element | null);
    if (el && !el.title) el.title = (el.textContent ?? '').trim();
  };
  document.addEventListener('mouseover', show, { passive: true });
  document.addEventListener('focusin', show);
}
